import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Users", -1);
var _hoisted_2 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "User status")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "Search")])], -1);
var _hoisted_4 = {
  "class": "px-2 pb-4"
};
var _hoisted_5 = {
  "class": "px-2 pb-4"
};
var _hoisted_6 = {
  "class": "w-full flex items-center rounded-md border border-resborder h-10 mr-4 p-2"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  "class": "res-btn-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "/images/res-search.svg"
})], -1);
var _hoisted_8 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6"
};
var _hoisted_9 = {
  "class": "flex justify-end"
};
var _hoisted_10 = {
  "class": "m-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_switch = _resolveComponent("el-switch");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Users"
  }), _hoisted_1, _createElementVNode("table", _hoisted_2, [_hoisted_3, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_4, [_createVNode(_component_el_select, {
    modelValue: $data.userStatus,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.userStatus = $event;
    }),
    filterable: "",
    onChange: _cache[1] || (_cache[1] = function ($event) {
      return $options.getUserList(true);
    })
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_option, {
        value: "all",
        label: "All"
      }), _createVNode(_component_el_option, {
        value: "active",
        label: "Active"
      }), _createVNode(_component_el_option, {
        value: "inactive",
        label: "Inactive"
      })];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("td", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_input, {
    "class": "w-full focus:shadow focus:outline-none border-none rounded-md text-sm",
    modelValue: $data.searchValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.searchValue = $event;
    }),
    placeholder: "search",
    "suffix-icon": "Search",
    clearable: true,
    onChange: _cache[3] || (_cache[3] = function ($event) {
      return _this.getUserList(true);
    })
  }, null, 8, ["modelValue"])])])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingMapping,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.userList,
        style: {
          "width": "100%"
        }
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name"
          }), _createVNode(_component_el_table_column, {
            prop: "email",
            label: "Email"
          }), _createVNode(_component_el_table_column, {
            label: "Platform Access"
          }, {
            "default": _withCtx(function (scope) {
              return [_createVNode(_component_el_switch, {
                modelValue: scope.row.is_active,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return scope.row.is_active = $event;
                },
                "active-text": "Active",
                "inactive-text": "Inactive",
                onChange: function onChange($event) {
                  return $options.updateUserAccess(scope.row);
                },
                "class": "m-2"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "LinkedIn Tool Access"
          }, {
            "default": _withCtx(function (scope) {
              return [_createVNode(_component_el_switch, {
                modelValue: scope.row.allow_extension,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return scope.row.allow_extension = $event;
                },
                "active-text": "Active",
                "inactive-text": "Inactive",
                onChange: function onChange($event) {
                  return $options.updateUserAccess(scope.row);
                },
                "class": "m-2"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingPaginate,
    animated: "",
    count: 1
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: $data.totalCount,
        "current-page": $data.currentPage,
        onCurrentChange: $options.pageChange
      }, null, 8, ["total", "current-page", "onCurrentChange"])];
    }),
    _: 1
  }, 8, ["loading"])])])])]);
}